import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import { GET_TRADE_ORDERS } from "../../Action/actionTypes";
import {
  notifyError,
} from "../../../Utils/Helper";
import { getTradeOrdersFailure, getTradeOrdersSuccess } from "../../Action/dashboard/tradeOrderAction";
import Constants from "../../../Utils/Constants";

function* getTradeOrdersRequest(actions) {
  try {
    const { accountno, sdate, edate, page, pageSize, filter } = actions?.payload || {};
  
   
    
    const payload = {
      accountno,
      sdate,
      edate,
      page,
      pageSize,
      filter
    };

    const { data } = yield call(API.post, `/trade-order?type=${Constants.GET_DEAL_PARAMS}`, payload); 
    if (data?.meta?.code === 200) {
      // Extract trade orders, pagination info, and summary from the new response structure
      const tradeOrders = data?.data?.data || [];
      const pagination = data?.data?.pagination || {};
      const summary = data?.data?.summary || {};
      yield put(getTradeOrdersSuccess({ tradeOrders, pagination, summary }));

      if (actions?.callback) {
        yield call(actions?.callback, data);
      }
    } else {
      yield put(getTradeOrdersFailure());
      notifyError(data?.meta?.message || "Failed to fetch trade orders");
    }
  } catch (error) {
    yield put(getTradeOrdersFailure());
    notifyError("Failed to fetch trade orders");
  }
}

export function* watchGetTradeOrdersAPI() {
  yield takeEvery(GET_TRADE_ORDERS, getTradeOrdersRequest);
}

export default function* tradeOrderSaga() {
  yield all([watchGetTradeOrdersAPI()]);
}